import { put, select } from 'redux-saga/effects';
import { enqueueErrorSnackbar } from '../notifications/actionWrapper';
import { translate } from '../../utils/translation';
import { selectSelectedLanguage } from './selectors';
import etrApi from '../utils/etrApi';
import { returnSnackbarMessage } from '../utils/utils';

export function fetchUserDataSagaFactory(actions) {
  return function* () {
    const lang = yield select(selectSelectedLanguage);
    try {
      const { data } = yield etrApi.get('ppm/user/current');
      // In order to test on different roles BU's etc comment out api call and uncomment const below
      // const data = {
      //   id: '1',
      //
      //   name: 'Spasija Andova',
      //
      //   email: 'spasija.andova1@ingka.com',
      //
      //   role: 'FM',
      //
      //   businessUnits: ['STO165', 'STO166'],
      //
      //   countries: ['US'],
      //
      //   clusters: ['North America'],
      // };
      if (data) {
        yield put(actions.fetchUserDataSuccess(data));
      }
    } catch (e) {
      yield put(actions.fetchUserDataError(e.message));
      yield put(
        enqueueErrorSnackbar(
          returnSnackbarMessage(
            e,
            translate('snackbarMessages.problemGettingUserData', lang),
          ),
        ),
      );
    }
  };
}
export function submitFeedBack(actions) {
  return function* ({ payload }) {
    try {
      yield etrApi.post('/ppm/user/feedback', { ...payload, source: 'ETR2' });
      yield put(actions.feedBackSubmitted());
    } catch (e) {
      yield put(actions.feedBackSubmitted());
      console.log(e);
    }
  };
}
